// ============================================================
// countOf - "1 map", "3 maps", "2 entries": a count and its noun,
// agreeing. The noun takes an "s" unless an irregular plural is given.
// ============================================================

/** `n` and the noun for it: `countOf(1, 'map')` is "1 map", `countOf(2, 'entry', 'entries')` "2 entries". */
export function countOf(n: number, singular: string, plural = singular + 's'): string {
  return `${n} ${n !== 1 ? plural : singular}`;
}
